<template>
    <div class="vehicle-info-card-redesign">
        <div class="card-title">{{ title }}</div>
        <ul class="vehicle-details-list">
            <li v-for="(detail, idx) in details" :key="idx" class="detail-item">
                <font-awesome-icon icon="check" class="check-icon" />
                <span class="detail-label">{{ detail.label }} :</span>
                <span class="detail-value">{{ detail.value }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "VehicleSummaryCard",
    props: {
        title: {
            type: String,
            default: "MON VÉHICULE"
        },
        details: {
            type: Array,
            required: true,
            // Expects [{ label, value }]
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/shared/VehicleSummaryCard.vue